import { styled } from '@compiled/react';
import { N0 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { layers } from '@atlassian/jira-common-styles/src/main.tsx';
import { BULK_ACTIONS_BAR_HEIGHT, ALIGN_TO_BACKLOG_CHECKBOXES_PADDING } from './constants';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BulkActionsBarWrapper = styled.div<{
	isVisible: boolean | null;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	paddingLeft: `${ALIGN_TO_BACKLOG_CHECKBOXES_PADDING}px`,
	paddingBottom: token('space.150', '12px'),
	paddingTop: token('space.050', '4px'),
	backgroundColor: token('elevation.surface', N0),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: BULK_ACTIONS_BAR_HEIGHT,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	visibility: ({ isVisible }) => {
		if (isVisible === null) {
			return 'unset';
		}

		return isVisible ? 'visible' : 'hidden';
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: layers.layer,
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StaticContainer = styled.div<{
	isOverlaid: boolean;
}>({
	position: 'sticky',
	top: 0,
	minWidth: '626px' /* Matches issue list container width */,
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: layers.layer,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `calc(${BULK_ACTIONS_BAR_HEIGHT}px + ${token('space.150', '12px')})`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	boxShadow: ({ isOverlaid }) =>
		isOverlaid
			? token(
					'elevation.shadow.overflow',
					'0px 0px 8px 0px rgba(9, 30, 66, 0.16), 0px 0px 1px 0px rgba(9, 30, 66, 0.12)',
				)
			: 'none',
});
